export default "__VITE_ASSET__BxiXO6Gh__"